enum ListVariantComponentType {
  Bar = 'bar',
  Card = 'card',
}

export default ListVariantComponentType
